import { useState, useEffect } from 'react';

// Custom hook to detect if the user is on a mobile device
function useMobileDetect() {
    const [isMobile, setIsMobile] = useState(() => {
        // Initial detection to prevent flashing
        if (typeof window === 'undefined') return false;
        
        // Check multiple methods for initial state
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
        const isMobileUserAgent = mobileRegex.test(userAgent);
        
        // Also check viewport width
        const isMobileWidth = window.innerWidth <= 768;
        
        // Check for touch support
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        
        return isMobileUserAgent || (isMobileWidth && isTouchDevice);
    });

    useEffect(() => {
        const checkMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            
            // More comprehensive mobile detection regex
            const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
            const isMobileUserAgent = mobileRegex.test(userAgent);
            
            // Check viewport width
            const isMobileWidth = window.innerWidth <= 768;
            
            // Check for touch support
            const isTouchDevice = 'ontouchstart' in window || 
                                navigator.maxTouchPoints > 0 || 
                                navigator.msMaxTouchPoints > 0;
            
            // Check for mobile-specific features
            const hasMobileFeatures = window.orientation !== undefined || 
                                    ('standalone' in window.navigator);
            
            // Combine all checks
            const isMobileDevice = isMobileUserAgent || 
                                 (isMobileWidth && isTouchDevice) || 
                                 hasMobileFeatures;
            
            setIsMobile(isMobileDevice);
        };

        // Initial check
        checkMobile();

        // Re-check on resize
        const handleResize = () => {
            checkMobile();
        };

        window.addEventListener('resize', handleResize);
        
        // Also check on orientation change
        window.addEventListener('orientationchange', checkMobile);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', checkMobile);
        };
    }, []);

    return isMobile;
}

export default useMobileDetect;
